import template from './contracts_help.html';
import * as Utils from '../../lib/savanna_utils.js';

class ContractsHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{	
		this.dialog.close();
	}
};

class ContractsHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new ContractsHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'ContractsHelp',
	dialog_class: ContractsHelpPage,
	template: template,
	template_filename: 'translation/dialogs/contracts_help',
	provider: 'ps'
};
